<template lang="pug">
  .component.component-invoice.invoice(v-if="item")
    .invoice-list(v-if="$is('listing')")
      .component-card
        .row.collapse
          .columns.shrink.align-self-middle
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
              invoice-action-buttons(:invoice="item")
          .columns
            .row
              .columns.align-self-middle
                invoice-fields(:item="item", :type="'invoice-number'")
                .type {{item.type}}

              .columns.align-self-middle
                invoice-fields(:item="item", :type="'invoice-emission-date'")
              .columns.align-self-middle
                invoice-fields(:item="item", :type="'invoice-due-date'")
              .columns.align-self-middle
                invoice-fields(:item="item", :type="'invoice-client-info'")
              .columns.align-self-middle
                invoice-fields(:item="item", :type="'invoice-tax'")
              .columns.align-self-middle
                invoice-fields(:item="item", :type="'invoice-total'")
              .columns.align-self-middle
                .field-value NET TO PAY:
                span {{$priceWithcurrency(item.total)}}
              .columns.align-self-middle
                invoice-fields(:item="item", :type="'invoice-status'")
          .columns.shrink.align-self-middle
            div.row.align-center.align-middle(slot="actionPage")
              is-module-enabled(module="italian-e-invoice")
                ActionButton(:action="downloadXML", :button="false")
                  .fa.fa-code.fa-2x(:style="xmlStatus")
              a.fa.fa-file-pdf-o.fa-2x(v-on:click="openUrl(item.url)")
              router-link(:to="{name:'invoice', params:{id:item.id}}")
                i.fa.fa-angle-right.fa-2x.action


    .invoice-list(v-if="$is('client-invoices')")
      .client-invoices
        .component-card
          .row
            .column.expand
              h3.mb-0 {{label}}{{item.internal_id}}({{item.number}})
              small(v-if="label === 'INV'")
                strong {{item.status}}
                span(v-if="item.status == 'PAID'") :&nbsp;{{$dateFormat(item.payed_on, $toMomentFormat(configuration.locale.locale_date_format.value))}}
            .column.shrink
              .field-content
                .label Emission
                .field-value  {{$dateFormat(item.emission_date, $toMomentFormat(configuration.locale.locale_date_format.value))}}
              .field-content(v-if="label !== 'CRN'")
                .label Due date
                .field-value {{$dateFormat(item.due_date, $toMomentFormat(configuration.locale.locale_date_format.value))}}
            .column.shrink(style="padding-left:0;padding-right:0")
              dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'", v-if="label === 'INV' || label === 'PRO'")
                invoice-action-buttons(:invoice="item")
          .row.text-center.pt-0.bottom
            .column.shrink.p-1
              .label Tax
              h3  {{$priceWithcurrency(item.tax)}}
            .column.shrink.p-1
              .label Subtotal
              h3  {{$priceWithcurrency(item.subtotal)}}
            .column.shrink.p-1
              .label Total
              h3  {{$priceWithcurrency(item.document_total)}}
            .column.shrink.p-1
              .label Net to Pay
              h3  {{$priceWithcurrency(item.total)}}
            .column.shrink
              label &nbsp;
              .row
                .column.shrink.pl-0.pr-0
                  is-module-enabled(module="italian-e-invoice")
                    ActionButton(:action="downloadXML", :button="false")
                      .fa.fa-code.fa-2x(:style="xmlStatus")
                .column.shrink.pl-0.pr-0
                  a.fa.fa-2x.fa-file-pdf-o(v-on:click="openUrl(item.url)")
                .column.shrink.pl-0.pr-0
                  router-link(:to="{name:'invoice', params:{id:item.id}}")
                    i.fa.fa-2x.fa-angle-right.action
    .client-invoices(v-if="$is('einvoice')")
      CardN(:columns="3")
        div(slot="n1") File name:
        div(slot="n1") {{item.uploadFileName}}
        div(slot="n2") {{item.errorCode}} - {{item.errorDescription}}
        div(slot="n3") Date
        div(slot="n3") {{item.created_at}}
    .invoice-list(v-if="$is('record-details')")


</template>
<script type="text/babel">
  import Accordion from '../../components/structure/foundation/Accordion'
  import Dropdown from 'components/structure/foundation/Dropdown'
  import MaggieHelper from '../../maggieHelper'
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import InvoiceActionButtons from '../structure/ui/actions/InvoiceButtons'
  import Transaction from 'components/backoffice/Transaction'
  import CardN from '../structure/CardN'
  import InvoiceFields from '../structure/ui/entity-fields/InvoiceFields.vue'
  import {mapState} from 'vuex'
  import IsModuleEnabled from '../structure/IsModuleEnabled'
  import ActionButton from '../structure/ui/ActionButton'

  export default {
    name: 'Invoice',
    components: {
      ActionButton,
      IsModuleEnabled,
      InvoiceFields,
      CardN,
      Transaction,
      InvoiceActionButtons,
      Accordion,
      Dropdown,
      MaggieHelper,
      KeplerBackofficeSdk
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {
      openUrl: function (url) {
        window.open(url, '_blank')
      },
      downloadXML() {
        return KeplerBackofficeSdk.invoices.select(this.item).downloadXML((data) => {
          window.open(data, '_blank')
        })
      },
      setChecked(item) {
        this.$emit('input', item.id)
      }
    },
    props: {
      item: Object,

      checked: {
        type: Boolean,
        default: false
      },
      value: {},
      type: {
        type: String,
        default: ''
      }
    },
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      }),
      label() {
        switch (this.item.type) {
          case 'INVOICE':
            return 'INV'
          case 'CREDIT NOTE':
            return 'CRN'
          case 'PROFORMA':
            return 'PRO'
        }
      },
      xmlStatus() {
        if (
          this.item.extra === undefined || this.item.extra === null ||
          this.item.extra.einvoice === undefined || this.item.extra.einvoice === null ||
          (this.item.extra.einvoice.hasOwnProperty('uploadedFileName') && this.item.extra.einvoice.uploadedFileName == null)
        ) {
          return {
            color: '#A3A3A3'
          }
        }
        const einvoice = this.item.extra.einvoice

        if (this.item.extra.hasOwnProperty('einvoice')) {
          switch (this.item.extra.hasOwnProperty('einvoice')) {
            case einvoice.is_invoice_rejected:
              return {
                color: 'red'
              }
            case einvoice.is_invoice_processing:
              return {
                color: '#ffae00'
              }
            case (einvoice.is_invoice_finalized && !einvoice.is_invoice_rejected):
              return {
                color: 'green'
              }
          }
        }
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-invoice
    .action-fields
      display: flex
      align-items: center

    .client-invoices
      //h3
        margin-bottom: 0
      .bottom
        justify-content: space-evenly

</style>




// WEBPACK FOOTER //
// Invoice.vue?5d060844